import Vue, { PluginObject, VueConstructor } from 'vue';

export type Waiter = string;

export type State = {
    waitingFor: Waiter[];
};

/**
 * Класс для работы с флагами загрузки чего-либо
 */
export class WaitService {
    /**
     * Реактивный стейт
     */
    private readonly _state: State = Vue.observable<State>({
        waitingFor: [],
    });
    /**
     * Стартует Waiter
     *
     * @param waiter
     */
    public start(waiter: Waiter) {
        if (!this.waiting(waiter)) {
            this._state.waitingFor.push(waiter);
        }
    }
    /**
     * Заканчивает Waiter
     *
     * @param waiter
     */
    public end(waiter: Waiter) {
        const i = this._state.waitingFor.indexOf(waiter);

        if (i >= 0) {
            this._state.waitingFor.splice(i, 1);
        }
    }
    /**
     * Есть ли Waiter?
     *
     * @param waiter
     * @returns
     */
    public waiting(...waiters: Waiter[]): boolean {
        for (let i = 0; i < waiters.length; i++) {
            // use es5 compatible
            if (this._state.waitingFor.indexOf(waiters[i]) >= 0) {
                return true;
            }
        }

        return false;
    }
}

export const WaitPlugin: PluginObject<Vue> = {
    async install(Vue: VueConstructor) {
        const service = new WaitService();

        Object.defineProperty(Vue.prototype, '$wait', {
            get() {
                return service;
            },
        });
    },
};
